import { render } from "./SystemModules.vue?vue&type=template&id=a734228e"
import script from "./SystemModules.vue?vue&type=script&lang=js"
export * from "./SystemModules.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__